module.exports = __webpack_public_path__ + "static/media/G5.9645d7ba.wav";